module.exports = __webpack_public_path__ + "static/pattern-style-3-2e6ef6bc7a3176d86adc4496348ed625.png";